import { useNavigate } from "react-router-dom";
import i18n from "../../../language/i18n";
import { Icon } from "../../../library";
import AnnouncementListView from "../announcements/AnnouncementListView";
import { announcementStyles } from "./AnnouncementStyles";

const Announcement = ({ dataTour }: { dataTour?: string }) => {
  const navigate = useNavigate();
  return (
    <div className="qce-root" data-tour={dataTour}>
      <style>{announcementStyles}</style>
      <div className="qce-header">
        <div className="qce-title-group">
          <Icon name="announcement" size={20} />
          <p className="qce-title">{i18n.t("announcements")}</p>
        </div>
        <div
          className="qce-see-all-button"
          onClick={() => {
            navigate("/announcements");
          }}
        >
          <p className="qce-see-all-text">{i18n.t("see_all")} →</p>
        </div>
      </div>
      <div className="qce-list-container no-scrollbar">
        <AnnouncementListView isMinimized={true} />
      </div>
    </div>
  );
};

export default Announcement;
